import { useEffect, useState } from "react";

export const MOBILE_BREAKPOINT_PX = 768;

export const useIsMobile = (breakpointPx: number = MOBILE_BREAKPOINT_PX) => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(`(max-width: ${breakpointPx}px)`).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpointPx}px)`);
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [breakpointPx]);

  return isMobile;
};
